import LogRocket from 'logrocket'
import mixpanel from 'mixpanel-browser'
import { store } from '../store'
import _omit from 'lodash/omit'
import {
  capturePosthog,
  identifyPosthogDistinctId,
  identifyPosthogWithPerson
} from './posthog-client'

function identifyUser (userId) {
  mixpanel.identify(userId)
  identifyPosthogDistinctId(userId)
}

function setUserInfo (data) {
  mixpanel.people.set({
    "$email": data.email,
    "$name": data.name,
    "$organization": data.orgName,
    "$role": data.role
  })
  identifyPosthogWithPerson(data.id, {
    email: data.email,
    name: data.name,
    organization: data.orgName,
    role: data.role
  })
  gtag('set', 'user_properties', {
    organization: data.orgName,
    role: data.role,
    name: data.name
  })
  LogRocket.identify(data.id, _omit({...data}, ['id']))
}

function trackEvent (event, props) {
  // If user is impersonated, do not track events
  if (store.getters.impersonatedUserId) {
    return
  }

  const defaultData = {
    isRunningFromApp: !!window.matchMedia('(display-mode: standalone)').matches
  }

  const payload = props ? { ...props, ...defaultData } : defaultData

  mixpanel.track(event, payload)

  capturePosthog(event, payload)
}

export {
  identifyUser,
  setUserInfo,
  trackEvent
}


// WEBPACK FOOTER //
// ./src/lib/track-events.js